export const UserPic:string[]=[
    `${process.env.REACT_APP_STAT_URL}/avatars/zero.png`,
    `${process.env.REACT_APP_STAT_URL}/avatars/first.png`,
    `${process.env.REACT_APP_STAT_URL}/avatars/second.jpeg`,
    `${process.env.REACT_APP_STAT_URL}/avatars/three.png`,
    `${process.env.REACT_APP_STAT_URL}/avatars/four.jpeg`,
    `${process.env.REACT_APP_STAT_URL}/avatars/five.jpeg`,
    `${process.env.REACT_APP_STAT_URL}/avatars/six.png`,
    `${process.env.REACT_APP_STAT_URL}/avatars/seven.jpeg`,
    `${process.env.REACT_APP_STAT_URL}/avatars/eight.png`]